__turbopack_context__.v({
  "badgeWidth": "O9nl3q_badgeWidth",
});
